(() => {
  if (!window.Dallas || window.Dallas.enableCustomCursor === false) return;

  const mq = window.matchMedia('(pointer: fine) and (min-width: 768px)');
  if (!mq.matches) return;

  const dot = document.querySelector('.cursor-dot');
  const ring = document.querySelector('.cursor-ring');
  if (!dot || !ring) return;

  const pos = { x: 0, y: 0 };
  let ringX = 0;
  let ringY = 0;
  let hovering = false;
  let raf = null;

  const isLightBg = (el) => {
    let node = el;
    while (node && node !== document.documentElement) {
      const bg = getComputedStyle(node).backgroundColor;
      if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') {
        const match = bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
        if (match) {
          const [r, g, b] = match.slice(1).map(Number);
          const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
          return luminance > 0.6;
        }
      }
      node = node.parentElement;
    }
    return true;
  };

  const setInverted = (inverted) => {
    if (inverted) {
      dot.style.background = '#ffffff';
      ring.style.borderColor = 'rgba(255,255,255,0.8)';
    } else {
      dot.style.background = getComputedStyle(document.documentElement).getPropertyValue('--dallas-pink') || '#E6127A';
      ring.style.borderColor = 'rgba(230,18,122,0.6)';
    }
  };

  const onMove = (e) => {
    pos.x = e.clientX;
    pos.y = e.clientY;
  };

  const onEnter = (e) => {
    hovering = true;
    ring.style.transform = `translate(${ringX}px, ${ringY}px) translate(-50%, -50%) scale(1.8)`;
    dot.style.transform = `translate(${pos.x}px, ${pos.y}px) translate(-50%, -50%) scale(0)`;
    setInverted(!isLightBg(e.currentTarget));
  };

  const onLeave = () => {
    hovering = false;
    ring.style.transform = `translate(${ringX}px, ${ringY}px) translate(-50%, -50%) scale(1)`;
    dot.style.transform = `translate(${pos.x}px, ${pos.y}px) translate(-50%, -50%) scale(1)`;
    setInverted(false);
  };

  const animate = () => {
    ringX += (pos.x - ringX) * 0.18;
    ringY += (pos.y - ringY) * 0.18;
    dot.style.transform = `translate(${pos.x}px, ${pos.y}px) translate(-50%, -50%)`;
    ring.style.transform = `translate(${ringX}px, ${ringY}px) translate(-50%, -50%)${hovering ? ' scale(1.8)' : ''}`;
    raf = requestAnimationFrame(animate);
  };

  const selector = 'a, button, input, textarea, select, [role="button"], label, [data-wishlist-toggle]';
  const bind = () => {
    document.querySelectorAll(selector).forEach((el) => {
      el.addEventListener('mouseenter', onEnter);
      el.addEventListener('mouseleave', onLeave);
    });
  };

  window.addEventListener('mousemove', onMove, { passive: true });
  const observer = new MutationObserver(bind);
  observer.observe(document.body, { childList: true, subtree: true });

  // Hide native cursor on interactive elements only
  const styleEl = document.createElement('style');
  styleEl.textContent = `${selector} { cursor: none !important; }`;
  document.head.appendChild(styleEl);

  raf = requestAnimationFrame(animate);
  bind();
})();
